<template>
  <div class="card card-body">
    <v-search-field
      @search="filterObjects"
      @reset="reset"
      :show-reset="objectList.length > 0"
      placeholder="sentence.search_dashboard"
    />

    <div v-if="objectList.length > 0">
      <hr/>
      <div class="row">
        <div
          class="col-md-6 col-lg-4"
          v-for="(research, index) in objectList"
          :key="research.id"
        >
          <v-reviewer-research-card
            :research="research"
            :index="index + 1"
          />
        </div>
      </div>
      <div class="m-3 d-flex justify-content-center align-items-center" v-if="nextPageUrl">
        <v-button
          v-if="nextPageUrl"
          text="phrase.load_more"
          @click="getObjects(nextPageUrl, true)"
        />
      </div>
    </div>
    <div class="alert alert-primary mt-2 text-center" v-else-if="searchQuery && !loading">
      {{ $t('phrase.no_commercials_found') }}
    </div>

    <v-loader v-if="loading" />
  </div>
</template>

<script>
import Button from '@/common/components/Button.vue';
import Loader from '@/common/components/Loader.vue';
import SearchField from '@/common/components/SearchField.vue';
import { GenericListMixin } from '@/common/utils/mixins';
import ReviewerResearchCard from '@/reviewer/components/ReviewerResearchCard.vue';

export default {
  name: 'ResearchSearch',
  components: {
    'v-button': Button,
    'v-reviewer-research-card': ReviewerResearchCard,
    'v-search-field': SearchField,
    'v-loader': Loader,
  },
  mixins: [
    GenericListMixin,
  ],
  methods: {
    getParams() {
      return {
        is_commercial: true,
      };
    },
    filterObjects(searchQuery) {
      this.searchQuery = searchQuery;
      this.getObjects();
    },
  },
  data() {
    return {
      apiPath: 'rev/researches/',
      getObjectsOnCreated: false,
    };
  },
};
</script>
